import { render, staticRenderFns } from "./DelOrgItem.vue?vue&type=template&id=763b3bce&scoped=true"
import script from "./DelOrgItem.vue?vue&type=script&lang=js"
export * from "./DelOrgItem.vue?vue&type=script&lang=js"
import style0 from "./DelOrgItem.vue?vue&type=style&index=0&id=763b3bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763b3bce",
  null
  
)

export default component.exports